import Vue from 'vue'

import { extend, localize, configure, ValidationObserver, ValidationProvider } from 'vee-validate'

import {
  required,
  email,
  integer,
  min,
  max,
  between,
  // eslint-disable-next-line camelcase
  min_value,
  // eslint-disable-next-line camelcase
  max_value,
  numeric,
  regex
} from 'vee-validate/dist/rules'

// Localization
import nl from 'vee-validate/dist/locale/nl.json'
localize('nl', nl)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

// Configuration VeeValidate
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  bails: true,
  skipOptional: true,
  mode: 'eager',
  useConstraintAttrs: true
})

// Overwrite the translation messages
localize({
  nl: {
    messages: {
      required: 'Dit veld is verplicht',
      email: 'Dit is geen geldig e-mailadres',
      integer: 'Vul alleen getallen in',
      min: (_, { length }) => `Dit veld moet minimaal ${length} karakters bevatten`,
      max: (_, { length }) => `Dit veld mag niet meer dan ${length} karakters bevatten`,
      minmax: 'Dit veld moet minimaal {min} karakters bevatten en maximaal {max}',
      zipcode: 'Juiste notatie: 1234AB, 1234 AB of 1234',
      phoneNumber: 'Dit is geen geldig telefoonnummer. Voer een juist telefoonnummer in om door te gaan',
      password: 'Wachtwoorden komen niet overeen',
      birthdate: 'Geboortedatum is onjuist',
      iban: 'IBAN is onjuist, juiste notatie: NL99 BANK 0123 4567 89'
    }
  }
})

// Install the validations
extend('required', required)
extend('email', email)
extend('integer', integer)
extend('min', min)
extend('max', max)
extend('between', between)
extend('min_value', min_value)
extend('max_value', max_value)
extend('numeric', numeric)
extend('regex', regex)

// Custom validation rules
extend('minmax', {
  validate(value, { min, max }) {
    return value.length >= min && value.length <= max
  },
  params: ['min', 'max']
})

extend('zipcode', {
  validate(value) {
    return /^[1-9][0-9]{3}\s?([a-z]{2})?$/i.test(value.replace(/\s/g, ''))
  }
})
// Regex for valid Dutch phone numbers
extend('phoneNumber', {
  validate(value) {
    return /^((\+|00(\s|\s?-\s?)?)31(\s|\s?-\s?)?(\(0\)[-\s]?)?|0)[1-9]((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/.test(
      value
    )
  }
})

extend('birthdate', {
  validate(value) {
    return /^(0[1-9]|[12][0-9]|3[01])[- -.](0[1-9]|1[012])[- -.](19|20)\d\d$/.test(value)
  }
})

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  }
})

extend('iban', {
  validate(value) {
    return /^([A-Z]{2}[ -]?[0-9]{2})(?=(?:[ -]?[A-Z0-9]){9,30}$)((?:[ -]?[A-Z0-9]{3,5}){2,7})([ -]?[A-Z0-9]{1,3})?$/.test(
      value.replace(/\s/g, '')
    )
  }
})
